module.exports = __webpack_public_path__ + "static/media/image12.224c8e47.JPG";